import {Component, ElementRef, EventEmitter, Input, Output, ViewChild} from '@angular/core';
import {DomSanitizer, SafeResourceUrl} from '@angular/platform-browser';
import {ToastrService} from 'ngx-toastr';
import {MatDialog} from '@angular/material/dialog';

@Component({
  selector: 'app-documents',
  templateUrl: './documents.component.html',
  styleUrls: ['./documents.component.scss']
})
export class DocumentsComponent {

  fileHovered: boolean;

  canDrop: boolean = false;

  files: FileWrapper[] = [];

  @ViewChild('documentlist')
  documentList: ElementRef;

  @Input()
  set clear(v){
    this.files = [];
  }

  @Output()
  selectedFiles: EventEmitter<File[]> = new EventEmitter<File[]>();

  constructor(private sanitizer: DomSanitizer, private toastrService: ToastrService, private matDialog: MatDialog) { }

  isAdvancedUpload(): boolean{
    const div = document.createElement('div');
    return (('draggable' in div) || ('ondragstart' in div && 'ondrop' in div)) && 'FormData' in window && 'FileReader' in window;
  }


  fileAdded(event: DragEvent) {
    this.fileHovered = false;

    this.addFiles(event.dataTransfer.files);
  }

  fileSelected(event: Event) {

    const targetElement = event.target as HTMLInputElement;
    this.addFiles(targetElement.files);
  }

  onFileDragStart(event: any): void {
    this.fileHovered = true;
    this.canDrop = containsOnlyAcceptedFiles(event.dataTransfer.items);
    event.preventDefault();
    event.stopPropagation();
  }

  onFileDragEnd(event: any): void {
    this.fileHovered = false;
    this.canDrop = true;
    event.preventDefault();
    event.stopPropagation();
  }

  onFileDropped(event: any): void {
    if (this.canDrop) {
      this.fileAdded(event);
    }
    this.canDrop = true;
    event.preventDefault();
    event.stopPropagation();
  }

  addFiles(files: FileList){
    for (let i = 0; i < files.length; i++){
      const droppedFile = files.item(i);

      if ((this.getSizeOfCurrentFiles() + droppedFile.size) >= 104857600){
        this.toastrService.error(
          'Achtung, das maximale Limit von 100 MB ist überschritten. ' +
          'Die Datei ' + droppedFile.name + ' konnte daher nicht hinzugefügt werden. ' +
          'Bitte entfernen Sie mind. eine Datei, um weitere Dateien hochzuladen.'
        );
      } else {
        const fileUrl =  (window.URL ? URL : webkitURL).createObjectURL(droppedFile);
        const safeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(fileUrl);
        this.files.push({
          randomId: Math.random().toString(36).substr(2, 9),
          url: safeUrl,
          rawUrl: fileUrl,
          file: droppedFile
        });
      }
    }

    this.publishFiles();
    this.documentList.nativeElement.scrollIntoView({behavior: 'smooth'});
  }

  getSizeOfCurrentFiles(){
    return this.files.map(file => file.file.size).reduce((a, b) => a + b, 0);
  }

  isImage(file: FileWrapper): boolean {
    return !!file.file.name.match(/\.(jpg|jpeg|png|gif)$/i);
  }

  remove(randomId: string) {
    this.files = this.files.filter(f => f.randomId !== randomId);
    this.publishFiles();
  }

  publishFiles(){
    this.selectedFiles.emit(
      this.files.map(file => file.file)
    );
  }

  showHint() {
    this.matDialog.open(DocumentHintDialogComponent);
  }
}

export class FileWrapper {
  randomId: string;
  url: SafeResourceUrl;
  rawUrl: string;
  file: File;
}
@Component({
  selector: 'app-document-hint',
  templateUrl: 'document-hint.html',
  styleUrls: ['document-hint.scss']
})
export class DocumentHintDialogComponent {
}

/**
 * Checks if the passed file list only contains accepted mime types.
 * This has to be kept in sync with the 'accept' attribute in the template that
 * uses a slightly different syntax.
 */
const containsOnlyAcceptedFiles = (items: DataTransferItemList): boolean => {
  // @ts-ignore
  return ![...items].some((file) => !file.type.match(/^image\/|^application\/pdf$/));
};
